import React from 'react';
import { PropTypes } from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import '../personal-info/PersonalInfo.scss';
import CardWithTitleButton from '../../card-widget/CardWithTitleButton'
import { RouteConstants } from "../../route/services/RouteConstants";
import PasswordInfoBlock from './PasswordInfoBlock';
import PasswordInfoEdit from './PasswordInfoEdit';
import ActionButton from '../../button/ActionButton';

const PasswordInfo = (props) => {
    let { onEdit, profile, lang, profileUpdated } = props;
    let isEditing = props.location.pathname === RouteConstants.EDIT_PASSWORD_INFO;
    let isDisabled = props.location.pathname !== RouteConstants.PROFILE &&
        props.location.pathname !== RouteConstants.EDIT_PASSWORD_INFO;

    let buttonLabel = isEditing ? '' : 'profile.password_info.edit_button';
    return (
        <CardWithTitleButton onTitleButtonClick={onEdit} titleKey='profile.password_info.title'
            buttonLabelKey={buttonLabel} buttonClass="hrb-profile-button" isDisabled={Boolean(isDisabled)}>
            <Switch>
                <Route path={RouteConstants.EDIT_PASSWORD_INFO} render={(props) => (
                    <PasswordInfoEdit {...props} profile={profile} lang={lang} profileUpdated={profileUpdated} />
                )} />
                <Route path='*' render={(p) => (<PasswordInfoBlock  />)} />
            </Switch>
            {buttonLabel &&
                <ActionButton text={buttonLabel} onClick={onEdit} buttonClass="hrb-profile-secondary-button" />
            }
        </CardWithTitleButton>
    );
}

PasswordInfo.propTypes = {
    onEdit: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    profileUpdated: PropTypes.func.isRequired
};

export default withRouter(PasswordInfo);